<template>
  <div
    class="layout upload-model flex items-center justify-center fixed inset-0 bg-smoke-darkest px-4 z-[100]"
    @click="closeModel"
  >
    <div
      class="model lg:max-w-xl max-w-md w-full h-fit bg-white shadow-md animate-scale rounded-xl p-4"
      @click.stop
    >
      <CloseIcon
        class="ml-auto p-1 border rounded-lg cursor-pointer"
        @click="closeModel"
      />
      <div>
        <p class="flex items-center flex-wrap gap-1 text-lg text-center mb-4">
          {{ props.message }}
          <span class="text-red-600 font-bold text-sm">{{
            props.item?.name ? `${props.item.name}` : ( (props.item?.id) ? props.item.id : '' )
          }}</span>
        </p>
        <p v-if="!props.message">
          {{ 'Are you sure you want to delete this item?' }}
        </p>
        <div class="flex items-center justify-end gap-3 mt-4">
          <VButton class="w-fit" variant="danger" @click="emit('deleteItem')">
            {{ translate('general.buttons.delete', props.pageLang) }}
          </VButton>
          <VButton
            class="w-fit"
            variant="secondary"
            @click="emit('closeModel')"
          >
            {{ translate('general.buttons.close', props.pageLang) }}
          </VButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Import Vue Packages
import { X as CloseIcon } from 'lucide-vue-next'

// Import Vue Custom Components
import { translate } from 'src/utils/translation'

// Variables
const emit = defineEmits(['closeModel', 'deleteItem'])
const props = defineProps<{
  message?: string
  item?: any
  pageLang?: string
  pageDir?: string
}>()

// Functions
const closeModel = () => emit('closeModel')
</script>
